import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronDownIcon } from 'lucide-react';
const faqs = [{
  question: '¿Necesito experiencia previa en tricotín?',
  answer: 'No, para nada. El kit está diseñado desde cero para principiantes. Incluye plantillas con flechas direccionales, guías paso a paso y videos tutoriales para que puedas crear tu primera pieza sin ningún conocimiento previo.'
}, {
  question: '¿Qué incluye exactamente el kit?',
  answer: 'Recibes más de 250 plantillas imprimibles a escala real, videos tutoriales paso a paso, una guía completa de 0 a tu primera pieza terminada, y 10 bonos exclusivos que incluyen moldes premium, guía de macramé, paleta de colores, tabla de precios y mucho más.'
}, {
  question: '¿Cómo recibo el producto después de comprarlo?',
  answer: 'El acceso es 100% digital e inmediato. Una vez que realizas el pago, recibes un enlace de descarga al instante en tu correo electrónico. Puedes acceder desde cualquier dispositivo: celular, tablet o computadora.'
}, {
  question: '¿Por cuánto tiempo tengo acceso al material?',
  answer: 'El acceso es de por vida. Una vez que descargas el kit, es tuyo para siempre. Puedes imprimir las plantillas cuantas veces quieras y ver los videos tutoriales cuando lo necesites, sin límites ni suscripciones.'
}];
export function FAQSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);
  const toggle = (index: number) => {
    setOpenIndex(openIndex === index ? null : index);
  };
  return <section className="py-20 bg-transparent border-t border-mint/20" data-id="element-17">
      <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-18">
        <div className="text-center mb-14" data-id="element-19">
          <motion.h2 initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="text-3xl md:text-4xl font-serif font-bold text-dark" data-id="element-20">
            Preguntas Frecuentes
          </motion.h2>
          <motion.p initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: 0.1
        }} className="mt-4 text-lg text-muted" data-id="element-21">
            Resolvemos tus dudas antes de empezar
          </motion.p>
        </div>

        <div className="space-y-3" data-id="element-22">
          {faqs.map((faq, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 15
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.08
        }} data-id="element-23">
              <button onClick={() => toggle(index)} className="w-full bg-white rounded-2xl px-6 py-5 flex items-center justify-between gap-4 text-left shadow-sm border border-gray-100 hover:shadow-md transition-shadow duration-200" aria-expanded={openIndex === index} data-id="element-24">
                <span className="font-bold text-dark text-sm md:text-base leading-snug" data-id="element-25">
                  {faq.question}
                </span>
                <motion.div animate={{
              rotate: openIndex === index ? 180 : 0
            }} transition={{
              duration: 0.25
            }} className="shrink-0" data-id="element-26">
                  <ChevronDownIcon className="w-5 h-5 text-muted" data-id="element-27" />
                </motion.div>
              </button>

              <AnimatePresence initial={false} data-id="element-28">
                {openIndex === index && <motion.div initial={{
              height: 0,
              opacity: 0
            }} animate={{
              height: 'auto',
              opacity: 1
            }} exit={{
              height: 0,
              opacity: 0
            }} transition={{
              duration: 0.3,
              ease: 'easeInOut'
            }} className="overflow-hidden" data-id="element-29">
                    <div className="px-6 pt-2 pb-5 text-muted text-sm md:text-base leading-relaxed" data-id="element-30">
                      {faq.answer}
                    </div>
                  </motion.div>}
              </AnimatePresence>
            </motion.div>)}
        </div>
      </div>
    </section>;
}